export interface MemorizedSuggestion {
  expenseCode: string;
  departmentId: string | null;
}

export function MemorizedCodingChip({
  suggestion,
  currentCode,
  onApply,
}: {
  suggestion: MemorizedSuggestion | null;
  currentCode: string;
  onApply: (s: MemorizedSuggestion) => void;
}) {
  if (!suggestion) return null;
  const applied = currentCode === suggestion.expenseCode;
  return (
    <span
      className="badge neutral"
      style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
    >
      จำจากครั้งก่อน: {suggestion.expenseCode}
      {!applied && (
        <button type="button" className="btn sm ghost" onClick={() => onApply(suggestion)}>
          ใช้ {suggestion.expenseCode}
        </button>
      )}
    </span>
  );
}
